export default class Constant {
  public static readonly ACCESS_TOKEN = 'access_token'
  public static readonly REFRESH_TOKEN = 'refresh_token'
  public static readonly PERMISSIONS = 'permissions'
  public static readonly DEFAULT_PAGE = 1
  public static readonly DEFAULT_SIZE = 10 //TODO: De test Phan trang
  public static readonly DEFAULT_SIZE_20 = 20 //TODO: De test Phan trang
  public static readonly MAX_SIZE = 10_000
  public static readonly DEFAULT_SORT_BY = 'id'
  public static readonly DEFAULT_SORT_DIRECTION = 'desc'
  public static readonly EMPTY_TEXT = '-'
  public static readonly PROCESSING = 'PROCESSING'
  public static readonly COMPLETED = 'COMPLETED'
  public static readonly DATE_INPUT_PLACEHOLDER = 'dd/mm/yyyy'
  public static readonly DEFAULT_FEE_FLOW = 1
  public static readonly INBOUND_FEE = 1
  public static readonly OUTBOUND_FEE = 2
  public static readonly IN_FEE = 1
  public static readonly OUT_FEE = 2
  public static readonly CHUNK_SIZE = 50 // moi lan scroll se hien 50 row (da fetch san tu backend roi). Tranh bi loi 1000 row render len component se bi lau (tam 10s)
  public static readonly DEFAULT_WIDTH = 100 // Mac dinh cot table tren may tinh
  public static readonly DEFAULT_MOBILE_WIDTH = 30 // Dien thoai

  // ── Sentinel "rỗng" dùng chung cho dropdown FILTER (tìm những dòng chưa có giá trị) ──
  // Dropdown FILTER khác dropdown EDIT (CLEAR_OPTION_LABEL bên dưới): FILTER dùng để tìm kiếm/lọc
  // ("cho tôi xem các dòng đang trống"), EDIT dùng để set giá trị về null ("xoá giá trị field này").
  // Xem docs/receive-backend/0013-filter-tren-table-cong-no.md và mục "Dropdown rỗng/xóa" trong CLAUDE.md.
  public static readonly FILTER_EMPTY_ID = -1 // Sentinel value cho field kiểu id (VD emp_billing_accountant_id)
  public static readonly FILTER_EMPTY_LABEL = '(Chỗ trống)' // Label hiển thị tương ứng

  // Label cho option "xoá giá trị" (value luôn là null) trong dropdown EDIT (inline-edit cell, modal
  // bulk-update...) - KHÔNG dùng để filter/tìm kiếm. Xem docs/receive-backend/0014-cong-no-bulk-update.md.
  public static readonly CLEAR_OPTION_LABEL = '(Bỏ trống)'

  /**
   * Số lượng item tối đa cho phép bật tính năng kéo thả.
   * Vô hiệu hóa nếu danh sách quá lớn để tránh giảm hiệu năng.
   */
  public static readonly MAX_SORTABLE_ITEMS = 500

  // Code loại xe "Ghép" — khi Loại xe từ CK về là GHEP thì auto fill phí nhóm 1_VC (Cước VC, Lưu xe)
  // tra cứu theo Loại xe sang tải (transload_vehicle_type_id) thay vì vn_vehicle_type_id.
  // Xem docs/0010-auto-fill-nhom-phi-van-chuyen-dau-vao.md.
  public static readonly VEHICLE_TYPE_CODE_GHEP = 'GHEP'

  // Loại cửa khẩu (field `gate_type` của danh mục Cửa khẩu — cột "Loại Cửa khẩu" ở BorderGatePage).
  // Dùng để suy ra chuyến là hàng Nhập hay Xuất, VD đặt tiêu đề tab trình duyệt lấy biển xe TQ (Nhập)
  // hay biển xe VN (Xuất) ở màn Chi tiết Theo dõi xe / Mở tờ khai.
  public static readonly BORDER_GATE_TYPE_IMPORT = 1
  public static readonly BORDER_GATE_TYPE_EXPORT = 2

  // TÊN Nhà cung cấp mặc định của nhóm phí TTCK đầu vào khi cửa khẩu thuộc danh sách
  // BORDER_GATE_TTCK_KEYWORDS (Xuân Cương, Viettel, Bằng Tường, Tân Thanh) — xem
  // src/constants/Permission.ts và watcher applyTtckDefaultSupplier ở VehicleTrackingStorePage.vue.
  // Khớp theo TÊN (bỏ dấu, không phân biệt hoa/thường) chứ không hardcode id vì id NCC khác nhau
  // giữa các môi trường (dev/staging/production).
  public static readonly TTCK_DEFAULT_SUPPLIER_NAME = 'TT'
}
